import { useEffect } from 'react';

export default function Tawk() {
    useEffect(() => {
        // Initialize Tawk.to API
        window.Tawk_API = window.Tawk_API || {};
        window.Tawk_LoadStart = new Date();

        // Create script element
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://embed.tawk.to/680464556eaad119189fd019/1ip8ifr52';
        script.charset = 'UTF-8';
        script.setAttribute('crossorigin', '*');

        // Find the first script tag and insert before it
        const firstScript = document.getElementsByTagName('script')[0];
        if (firstScript && firstScript.parentNode) {
            firstScript.parentNode.insertBefore(script, firstScript);
        } else {
            // Fallback: append to head if no script found
            document.head.appendChild(script);
        }

        // Cleanup function (optional, but good practice)
        return () => {
            // Remove script if component unmounts (though Tawk usually persists)
            const tawkScript = document.querySelector('script[src*="embed.tawk.to"]');
            if (tawkScript && tawkScript.parentNode) {
                tawkScript.parentNode.removeChild(tawkScript);
            }
        };
    }, []);

    return null;
}

